angular.module('tgaApp')
  .factory('redirectInterceptor', [
    '$window', '$q',
    ($window, $q) => ({
      responseError(error) {
        const redirect = error?.data?.redirect ?? false;
        if (redirect) {
          // eslint-disable-next-line no-param-reassign
          $window.location.href = redirect;
        }
        return $q.reject(error);
      },
    })]);

angular.module('tgaApp').config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('redirectInterceptor');
}]);
